import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
    ComponentsService,
    SIMULATION_GAME_CODE
} from 'src/app/components.service';

export interface minPerSel {
    Selection: string;
    minPayin: number;
}

@Component({
    selector: 'app-bet-settings',
    templateUrl: './bet-settings.component.html',
    styleUrls: ['./bet-settings.component.scss']
})
export class BetSettingsComponent implements OnInit {
    gameType: string;
    constructor(
        private readonly service: ComponentsService,
        private readonly activeRoute: ActivatedRoute
    ) {}
    disabledInputs = true;
    profileVG;
    myGroup;
    minPayin;
    maxPayin;
    maxPayout;
    profile;
    ccy;

    ELEMENT_DATA: minPerSel[] = [];
    displayedColumns: string[] = ['Selection', 'Min payin'];
    dataSource = this.ELEMENT_DATA;
    saveButtonActive = false;

    gameCode;
    incSource = [];
    clientUuid;
    settings: any;
    // refs
    @ViewChild('ccyInput') ccyInput: ElementRef;
    @ViewChild('minPayinInput') minPayinInput: ElementRef;
    @ViewChild('maxPayinInput') maxPayinInput: ElementRef;
    @ViewChild('maxPayoutInput') maxPayoutInput: ElementRef;
    @ViewChild('profileInput') profileInput: ElementRef;

    ngOnInit(): void {
        this.activeRoute.params.subscribe((data) => {
            this.clientUuid = this.service.getUsersPerm().clientUuid;
            this.gameCode = SIMULATION_GAME_CODE;
            this.populateTables(this.clientUuid, this.gameCode);
        });

        this.gameType = this.service.getSimulationGameType();
    }

    enableEdditing() {
        console.log('enableEdditing method called');
        this.saveButtonActive = true;
        this.disabledInputs = false;
        console.log('disabledInputs:', this.disabledInputs);
        console.log('saveButtonActive:', this.saveButtonActive);
    }

    saveSettings() {
        console.log('saveSettings method called');
        try {
            // Always collect the full array of increments from the DOM or fallback to incSource
            let increments: any = document.getElementsByClassName('increments');
            let incrementsArr: string[] = [];
            for (let i = 0; i < increments.length; i++) {
                let val =
                    increments[i].value && increments[i].value.trim() !== ''
                        ? increments[i].value.trim()
                        : this.incSource[i] !== undefined
                          ? this.incSource[i]
                          : '';
                incrementsArr.push(val);
            }
            let newIncrements = incrementsArr.join(',');
            let settingsToBeChanged: any = {};

            // Add common fields
            if (this.maxPayinInput?.nativeElement?.value) {
                settingsToBeChanged.maxPayin =
                    this.maxPayinInput.nativeElement.value;
            }
            if (this.maxPayoutInput?.nativeElement?.value) {
                settingsToBeChanged.maxPayout =
                    this.maxPayoutInput.nativeElement.value;
            }
            if (this.ccyInput?.nativeElement?.value) {
                settingsToBeChanged.ccy = this.ccyInput.nativeElement.value;
            }
            if (this.profileInput?.nativeElement?.value) {
                settingsToBeChanged.profile =
                    this.profileInput.nativeElement.value;
            }

            // Always send the full array of increments if any are present
            if (incrementsArr.length > 0) {
                settingsToBeChanged.ticketIncrements = newIncrements;
            }

            console.log('Settings to be changed:', settingsToBeChanged);
            console.log('Client UUID:', this.clientUuid);
            console.log('Game Code:', this.gameCode);

            this.service
                .changeBetSettings(
                    settingsToBeChanged,
                    this.clientUuid,
                    this.gameCode
                )
                .subscribe(
                    (data) => {
                        console.log('Response from changeBetSettings:', data);
                        if (data.success) {
                            console.log(
                                'Settings saved successfully:',
                                data.message
                            );
                            this.disabledInputs = true;
                            this.saveButtonActive = false;
                            this.populateTables(this.clientUuid, this.gameCode);
                        } else {
                            console.error(
                                'Failed to save settings:',
                                data.message
                            );
                        }
                    },
                    (error) => {
                        console.error('Error saving settings:', error);
                    }
                );
        } catch (error) {
            console.error('Error in saveSettings:', error);
        }
    }

    populateTables(clientUuid, gameCode) {
        this.service.getBettSettings(clientUuid, gameCode).subscribe((data) => {
            // Always set ccy to the correct value from the settings
            this.ccy = data.ccy;

            this.maxPayin = data.maxPayin || 'No data';
            this.maxPayout = data.maxPayout || 'No data';
            this.profile = data.profile || '0';

            // After ccy is set, always use it for increments
            this.service
                .getIncrements(this.clientUuid, this.gameCode, this.ccy)
                .subscribe((data) => {
                    console.log('Increments response:', data);

                    if (data.increments && Array.isArray(data.increments)) {
                        this.incSource = data.increments;
                    } else if (data.success === false) {
                        console.error(
                            'Failed to get increments:',
                            data.data?.message
                        );
                        this.incSource = [];
                    } else {
                        console.warn(
                            'Unexpected increments response format:',
                            data
                        );
                        this.incSource = [];
                    }
                });
        });
    }
}
